import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"search\"><path d=\"M17.5 9a9.5 9.5 0 100 19 9.5 9.5 0 000-19zm0 2a7.5 7.5 0 110 15 7.5 7.5 0 010-15z\" /><path d=\"M23.707 23.293l6 6-1.414 1.414-6-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol